import React from "react";
import "./ViewAllLink.css";

const ViewAllLink = ({ text = "VIEW ALL", onClick }) => {
  return (
    <div className="view-all-wrapper">
      <button className="view-all-link" onClick={onClick}>
        <span className="text">{text}</span>
        <span className="underline"></span>
      </button>
    </div>
  );
};

export default ViewAllLink;